export default __webpack_public_path__ + "static/media/thumb001.e31a7dca.png";